"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Page = require("../Page/Page.context");
var _PageContent = require("./PageContent.styles");
/**
 * Page content is a generic container that provides a consistent layout
 * for all `Page` components. It sets the max-width and defines
 * default padding and margins.
 *
 * You can use this component with your own custom components to make sure layouts are consistent.
 *
 * @since 8.15.0
 */
var PageContent = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _useContext = (0, _react.useContext)(_Page.PageContext),
    fluid = _useContext.fluid;
  return /*#__PURE__*/_react.default.createElement(_PageContent.StyledPageContent, (0, _extends2.default)({
    ref: forwardedRef,
    fluid: fluid
  }, props));
});
exports.PageContent = PageContent;
PageContent.displayName = 'PageContent';
PageContent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * By default, page components will be bound by the `Page.maxWidth` token.
   * Setting this to true will remove the max width bound.
   *
   * Setting this on `Page` will set `fluid` for all child page components.
   */
  fluid: _propTypes.default.bool
} : {};